<template>
  <b-modal
    v-model="show"
    size="lg"
    :title="title"
    :hide-footer="true"
  >
    <b-list-group>
      <b-list-group-item
        v-for="key in Object.keys(object)"
        :key="key"
      >
        <label>
          <b>{{ key }}</b>
        </label>
        <br>
        <!-- if the object value is not an image url -->
        <span v-if="!object[key].toString().includes('firebasestorage')">
          {{ object[key] }}
        </span>
        <!-- else if it is an image url -->
        <img
          v-else
          :src="object[key]"
          width="220"
        >
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    object: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    // it is used for avoiding direct prop mutation
    show: false,
  }),
  watch: {
    // when v-model is changed in parent, update show value
    value(val) {
      this.show = val;
    },
    // when show value is updated, emit new value to parent (v-model)
    show(val) {
      this.$emit('input', val);
    },
  },
  created() {
    this.show = this.value;
  },
};
</script>
<style scoped>

</style>
